export const ACTION_RESET = 'FETCH_FEATURES_RESET';
export const ACTION_REQUEST = 'FETCH_FEATURES_REQUEST';
export const ACTION_SUCCESS = 'FETCH_FEATURES_SUCCESS';
export const ACTION_ERROR = 'FETCH_FEATURES_ERROR';
